import React from 'react'
import { Flexgrid, TextInput, FlexgridItem } from '@wf-wfria/pioneer-core'
import {
	DOCEX,
	WFORMS,
	RICOH,
	RFI,
	ONBOARD,
	SBA,
	DLO,
	COBO,
	EASYCONNECT,
} from '../businessSegmentBrandIds'

export function ForgotUserIdContractNumber({
	formatMessage,
	contractNumber,
	onUpdateInput,
	onTextInputValidator,
	mode,
}) {
	if (
		mode === DOCEX ||
		mode === WFORMS ||
		mode === ONBOARD ||
		mode === SBA ||
		mode === RICOH ||
		mode === RFI ||
		mode === DLO ||
		mode === COBO ||
		mode === EASYCONNECT
	) {
		return null
	}

	function onChange({ id, value }) {
		onUpdateInput(id, value)
	}

	return (
		<Flexgrid>
			<FlexgridItem span={8}>
				<TextInput
					aria-label={formatMessage({
						id: 'wca-form.forgot-user-id.account-schedule-or-contract-number.label',
					})}
					label={formatMessage({
						id: 'wca-form.forgot-user-id.account-schedule-or-contract-number.label',
					})}
					aria-required={true}
					required={true}
					id="contractNumber"
					name="contractNumber"
					type="text"
					value={contractNumber.value}
					onValueChange={onChange}
					customValidators={[
						(value) => onTextInputValidator('contractNumber', value),
					]}
					nativeValidationMessages={{
						valueMissing: formatMessage({
							id: 'required-field.empty.error.label',
						}),
					}}
				/>
			</FlexgridItem>
		</Flexgrid>
	)
}
